module.exports = __webpack_public_path__ + "static/media/track-firecracker.57034bdb.png";